export class RoleEx {
    roleExId = null;
    code = null;
    name = null;
    description = null;
    permissions = null;
}